<script setup lang="ts">

    import { CaseStatus } from '@/api/caseSearch';

    import { computed } from 'vue';
    import ProcessingTracker from '@/views/case-settings/case-toasties/ProcessingTracker.vue';

    const props = defineProps<{
        caseStatus: CaseStatus;
    }>();

    const PROCESSING_MESSAGES: Partial<Record<CaseStatus, string>> = {
        [CaseStatus.GeneratingDicoms]: 'Your CT scan is being processed.',
        [CaseStatus.ImageSegmentation]: 'We are generating the 3D models for this case.',
        [CaseStatus.SurgicalTemplating]: 'Creating the most suitable template.',
        [CaseStatus.GeneratingPlan]: 'Templating completed. Generating your PDF report.',
    };

    const statusMessage = computed(() =>
        PROCESSING_MESSAGES[props.caseStatus],
    );

</script>

<template>
    <v-card width="389" class="mb-5">
        <v-layout>
            <v-icon
                class="ml-5 mt-3 notification-icon"
                size="25"
                color="info"
                style="opacity: 1"
                icon="f:info-tooltip"
            />
            <div class="ml-2 mt-1 pr-2">
                <v-card-title class="pl-2">Your Case is Processing</v-card-title>
                <v-card-text class="pl-2 pt-0 pb-2 justify-end">
                    {{ statusMessage }}
                </v-card-text>
            </div>
        </v-layout>
        <v-layout class="justify-center mt-1">
            <ProcessingTracker :current-status="caseStatus" />
        </v-layout>
    </v-card>
</template>

<style scoped lang="scss">

    :deep(.v-card-title) {
        font-weight: 700 !important;
        font-size: 14px !important;
    }

    :deep(.v-card-text) {
        font-weight: 400 !important;
        font-size: 14px;
    }

</style>
